import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { TechnicalTrainingService } from "src/app/core/services/technicalTrainins.service";
import { CloseNotifComponent } from "../close-notif/close-notif.component";

@Component({
  selector: "app-add-training",
  templateUrl: "./add-training.component.html",
  styleUrls: ["./add-training.component.scss"],
})
export class AddTrainingComponent implements OnInit {
  showTagalog: boolean = false;
  buttonColor: string = "accent";
  language: string = "Translate to Tagalog";
  textClass: string = "text-black"

  userData: any;

  trainingsFormGroup: FormGroup;

  successMessage: boolean = false
  errorMessage: boolean = false

  othersCertificate: any;
  isItemBeingAdded: boolean = false;
  isAddButtonDisabled: boolean = false;

  certifateTypes: any = [
    { id: 1, name: "NC I" },
    { id: 2, name: "NC II" },
    { id: 3, name: "NC III" },
    { id: 4, name: "NC IV" },
    { id: 5, name: "Others" },
  ];

  constructor(
    private fb: FormBuilder,
    private technicalTrainingService: TechnicalTrainingService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("applicantDetails"));

    this.trainingsFormGroup = this.fb.group({
      trainingCourse: ["", [Validators.required, this.notEmptyString]],
      hoursOfTraining: ["", Validators.required],
      trainingInstitution: ["", Validators.required],
      certificates: ["", Validators.required],
      certificatesOthers: [""],
      skillsAcquired: ["", [Validators.required, this.notEmptyString]],
    });
  }

  saveTraining() {
    if (this.trainingsFormGroup.invalid) {
      this.errorMessage = true;

      setTimeout(() => {
        this.errorMessage = false;
      }, 1000);
    } else {
      this.isAddButtonDisabled = true;
      this.isItemBeingAdded = true;

      const technicalTrainingData = {
        applicantId: this.userData?.id,
        trainingCourse: this.trainingsFormGroup.get("trainingCourse").value,
        hoursOfTraining: this.trainingsFormGroup.get("hoursOfTraining").value,
        trainingInstitution: this.trainingsFormGroup.get("trainingInstitution")
          .value,
        certificates: this.trainingsFormGroup.get("certificates").value,
        skillsAcquired: this.trainingsFormGroup.get("skillsAcquired").value,
      };

      const selectedCertificate = this.othersCertificate;

      if (selectedCertificate == "Others") {
        technicalTrainingData.certificates =
          this.trainingsFormGroup.get("certificatesOthers").value;

        this.technicalTrainingService
          .addTechnicalTraining(technicalTrainingData)
          .subscribe(
            (response) => {

              this.isItemBeingAdded = false;
              this.isAddButtonDisabled = false;

              this.successMessage = true

              setTimeout(() => {
                this.dialog.closeAll();
              }, 3000);
            },
            (error) => {
            }
          );
        return;
      } else {
        this.technicalTrainingService
          .addTechnicalTraining(technicalTrainingData)
          .subscribe(
            (response) => {

              this.isItemBeingAdded = false;
              this.isAddButtonDisabled = false;

              this.successMessage = true

              setTimeout(() => {
                this.dialog.closeAll();
              }, 3000);
            },
            (error) => {
            }
          );

        return;
      }
    }
  }

  onCertificateChange(event: any) {
    const selectedCertificate = event.value;

    this.trainingsFormGroup.get("certificatesOthers").clearValidators();

    if (selectedCertificate == "Others") {
      this.trainingsFormGroup
        .get("certificatesOthers")
        .setValidators([Validators.required, this.notEmptyString]);
    }

    this.trainingsFormGroup.get("certificatesOthers").updateValueAndValidity();
  }

  hideSuccessMessage() {
    this.successMessage = false;
  }

  closeNotif() {
    this.dialog.open(CloseNotifComponent);
  }

  notEmptyString(control) {
    const value = control.value;

    if (value === null || value.trim() === "") {
      return { notEmptyString: true };
    }

    return null;
  }

  toggleTagalogTranslation() {

    this.showTagalog = !this.showTagalog;
    this.language =
      this.language === "Translate to Tagalog"
        ? "Translate to English"
        : "Translate to Tagalog";

    this.buttonColor =
      this.language === "Translate to Tagalog" ? "accent" : "primary";
    this.textClass = this.language == "Translate to Tagalog" ? "text-black" : "text-white";
    
  }
}
